var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('head-bar'),_c('img',{attrs:{"src":_vm.banner,"alt":""}}),_c('input-out'),_c('keep-alive',{attrs:{"include":"HomePage"}},[_c('router-view',{staticClass:"main-body"})],1),_c('footer-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }